import {
  Button,
  NavBar,
  Icon,
  Toast,
  Tabs,
  WhiteSpace,
  SearchBar,
  List,
  InputItem,
  Modal,
  Result,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../../util/axios";
const JixiaoList = styled.div`
  .body {
    height: 100%;
  }
  .month p {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d7d7d7;
  }
  .pdd {
    padding: 0px 20px 0px 20px;
  }
`;
interface scoreArray {
  name: string;
  minScore: string;
  maxScore: string;
}
export default function PromotionDetails() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  const [starttimeList, setStarttimeList] = useState<{
    time: number;
  }>({ time: 1 });
  const [endtimeList, setEndtimeList] = useState<{
    time: number;
    status: string;
  }>({ time: 1, status: "" });
  const [informationList, setInformationList] = useState<{
    uuid: string;
  }>({
    uuid: "",
  });
  const history = useHistory();
  const [text, setText] = useState<string>("");
  const [detailsList, setDetailsList] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const [standardList, setStandardList] = useState<scoreArray[]>([]);
  // 评分标准
  useEffect(() => {
    instance
      .get(
        `/oa/examSetting/standardSetting/getScoreRangeStandardList?timeType=` +
          "month"
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setStandardList(resp.data.Data);
        }
      });
  }, []);
  useEffect(() => {
    // 获取现在时间
    const nowTime1 = new Date();
    const nowTime = nowTime1.getTime();
    console.log(nowTime);
    setStarttimeList({
      ...starttimeList,
      time: nowTime,
    });
    let url = decodeURI(window.location.href); //获取请求进来的完整url
    let tstr = url.substring(url.indexOf("?") + 1).split("&"); //先截取url的?后面的参数部分，在根据&分割成参数数组
    console.log(tstr);
    let tstr0 = tstr[0].substring(9);
    let tstr1 = tstr[1];
    setInformationList({
      uuid: tstr1,
    });
    instance
      .post(
        `/oa/adjust/getPromotionStaffList?vsheetId=` +
          tstr0 +
          "&isPromotion=" +
          "true"
      )
      .then((resp) => {
        // console.log(resp.data.Data.data);
        // console.log(resp);
        if (resp.data.Status == 1) {
          let arr = resp.data.Data.data;
          let data0 = arr.find((item: any) => item.uuid === tstr1);
          let staffName = data0.staffName;
          let departmentName = data0.departmentName;
          let workTypeId = data0.workTypeId;
          let positionName = data0.positionName;
          let nextLevel = data0.nextLevel;
          let curLevel = data0.curLevel;
          let curWorkYears = data0.curWorkYears;
          let relWorkYears = data0.relWorkYears;
          let jobRequired = data0.jobRequired;
          let reviewScore = data0.reviewScore; //绩效考核得分
          let perfactor = data0.perfactor; //绩效系数
          let reviewId = data0.reviewId;
          setText(reviewScore);
          setDetailsList({
            staffName,
            departmentName,
            workTypeId,
            positionName,
            nextLevel,
            curLevel,
            curWorkYears,
            relWorkYears,
            jobRequired,
            reviewScore,
            perfactor,
            reviewId,
          });
        }
      });
    instance.get(`/oa/adjust/getNoticeList`).then((resp) => {
      // console.log(resp);
      // console.log(resp.data.Data.data)
      if (resp.data.Status === "1") {
        let data1 = resp.data.Data.data.find(
          (item: any) => item.uuid === tstr0
        );
        console.log(data1);
        const khTime = new Date(data1.评审结束时间).getTime();
        console.log(khTime);
        const Status = data1.status;
        setEndtimeList({
          ...endtimeList,
          time: khTime,
          status: Status,
        });
      }
    });
  }, []);
  return (
    <>
      <JixiaoList>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  // history.push(`/hr/rankadjustment/promotionmanagement`);
                  history.go(-1);
                }}
              />
            }
          >
            考核
          </NavBar>
          <WhiteSpace />
          <div>
            <div style={{ padding: "10px 20px 10px 20px" }} className="month">
              <p>
                <span>被考核人</span>
                <span>{detailsList.staffName}</span>
              </p>
              <p>
                <span>部门</span>
                <span>{detailsList.departmentName}</span>
              </p>
              <p>
                <span>当前工作序列</span>
                <span>{detailsList.workTypeId}</span>
              </p>
              <p>
                <span>岗位</span>
                <span>{detailsList.positionName}</span>
              </p>
              <p>
                <span>拟晋升职级</span>
                <span>{detailsList.nextLevel}</span>
              </p>
              <p>
                <span>当前职级</span>
                <span>{detailsList.curLevel}</span>
              </p>
              <p>
                <span>当前职级工作年限</span>
                <span>{detailsList.curWorkYears}</span>
              </p>
              <p>
                <span>当前职级有效任职年限</span>
                <span>{detailsList.relWorkYears}</span>
              </p>
              <p>
                <span>有效任职年限内的绩效等级</span>
                <span>{detailsList.jobRequired}</span>
              </p>
              <p>
                <span>绩效考核得分</span>
                <span>{detailsList.perfactor}</span>
              </p>
              <p>
                <span>绩效系数</span>
                <span>{detailsList.perfactor}</span>
              </p>
              <p>
                <span>工作报告</span>
                <span>工作报告名</span>
              </p>
            </div>
            <List>
              <InputItem
                type="number"
                placeholder="必填"
                onVirtualKeyboardConfirm={(v) =>
                  console.log("虚拟键盘点击确认时的回调函数:", v)
                }
                maxLength={3}
                value={text}
                clear
                onChange={(value) => {
                  console.log(value);
                  setText(value);
                }}
                style={{ padding: "0px 20px 0px 20px" }}
              >
                <span style={{ color: "red" }}>*</span>绩效打分
              </InputItem>
            </List>
            <p className="pdd">
              <span
                style={{ color: "#108ee9" }}
                onClick={() =>
                  setTankuang({
                    visible: true,
                  })
                }
              >
                查看评价标准
              </span>
            </p>
            <div style={{ padding: "0px 20px 0px 20px", marginTop: 130 }}>
              {starttimeList.time > endtimeList.time ? (
                <Button
                  type="primary"
                  onClick={() => {
                    Toast.info("评审时间已过", 1);
                  }}
                >
                  提交
                </Button>
              ) : (
                <Button
                  type="primary"
                  onClick={() => {
                    if (text == "") {
                      Toast.info("请填写必填项");
                    } else {
                      instance
                        .post(
                          `/oa/adjust/savePromotionReview?uuid=` +
                            detailsList.reviewId +
                            "&score=" +
                            text +
                            "&reviewType=2"
                        )
                        .then((resp) => {
                          console.log(resp);
                          if (resp.data.Status === "1") {
                            Toast.info("评审成功");
                            setTimeout(function () {
                              history.go(-1);
                            }, 1500);
                          } else {
                            Toast.info("评审失败");
                          }
                        });
                    }
                  }}
                >
                  提交
                </Button>
              )}

              <WhiteSpace />
            </div>
            <Modal
              visible={tankuang.visible}
              transparent
              maskClosable={false}
              onClose={() =>
                setTankuang({
                  visible: false,
                })
              }
              title="评价标准"
              footer={[
                {
                  text: "关闭",
                  onPress: () => {
                    setTankuang({
                      visible: false,
                    });
                  },
                },
              ]}
            >
              <div style={{ height: 200, overflow: "scroll" }}>
                {standardList.map((item) => (
                  <>
                    <p>
                      {item.name}[{item.minScore},{item.maxScore})
                    </p>
                  </>
                ))}
              </div>
            </Modal>
          </div>
          {/* 暂无数据 */}
          {/* <Result
                        style={{
                            height: "calc(100vh - 136px)",
                        }}
                        img={
                            <Icon
                                type="cross-circle-o"
                                style={{
                                    width: 60,
                                    height: 60,
                                    color: "#1890ff",
                                }}
                            />
                        }
                        title="暂无内容"
                    /> */}
        </div>
      </JixiaoList>
    </>
  );
}
